/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Reset_Link_InvalidInputs */

const fr_error_reset_link_invalid = /** @type {(inputs: Error_Reset_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien n’est plus valide. Demandez un nouveau lien de réinitialisation.`)
};

const en_error_reset_link_invalid = /** @type {(inputs: Error_Reset_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is no longer valid. Request a new password-reset link.`)
};

/**
* | output |
* | --- |
* | "This link is no longer valid. Request a new password-reset link." |
*
* @param {Error_Reset_Link_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_reset_link_invalid = /** @type {((inputs?: Error_Reset_Link_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Reset_Link_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_reset_link_invalid(inputs)
	return fr_error_reset_link_invalid(inputs)
});